import { useTranslation } from 'react-i18next';

import { useDocsKeys } from '../../hooks/use-docs-keys';

/** The selected playground key's prefix inside prose, or a placeholder until one is picked. */
export function ApiKeyInline() {
  const { t } = useTranslation('docs');
  const { selectedKey } = useDocsKeys();
  return (
    <code
      data-selected={selectedKey ? 'true' : 'false'}
      className="bg-muted rounded px-[0.3rem] py-[0.2rem] font-mono text-[0.85em]"
    >
      {selectedKey ? `${selectedKey.prefix}…` : t('mdx.apiKeyPlaceholder')}
    </code>
  );
}
